<template>
	<div>
		<p v-for="notification in notifications" v-html="notification.description">
		</p>

		<div class="text-center" v-if="!notifications">
			{{ t.user.notfound.notifications }}
		</div>

	</div>
</template>

<script>
    export default {
        name: 'notifications',
        data () {
            return {
                t: this.$root.t,
                notifications: null
            }
        },
	    mounted () {
			this.fetchNotifications();
	    },
	    methods: {
            fetchNotifications () {
                this.$http.get(api+'api/v1/notifications')
                    .then(response => {

                        this.notifications = response.body.result.notification;

                    }, response => {

                        this.notifications = null;
                    })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	p{
		border-bottom: 1px solid #ccc;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/account/notifications.vue